<template>
  <page-header-wrapper>
    <div class="settings-page erp-list-page baidao-list-page basic-settings-page">
      <div class="page-intro">
        <h2>基础设置</h2>
        <p>统一维护客户、CRM 拓客、商品、库存与财务单据中的基础档案和可选内容。</p>
      </div>
      <div class="settings-layout">
        <aside class="settings-navigation" aria-label="基础设置分类">
          <a-menu mode="inline" :selected-keys="[activeType]" @click="selectType">
            <a-menu-item-group v-for="group in groups" :key="group.name" :title="group.name">
              <a-menu-item v-for="item in group.items" :key="item.type">{{ item.name }}</a-menu-item>
            </a-menu-item-group>
          </a-menu>
        </aside>
        <main ref="settingsContent" class="settings-content">
          <cash-account-table v-if="activeItem.custom === 'cashAccount'" :key="activeType" />
          <basic-option-table v-else :key="activeType" :item="activeItem" />
        </main>
      </div>
    </div>
  </page-header-wrapper>
</template>

<script>
import BasicOptionTable from './BasicOptionTable'
import CashAccountTable from './CashAccountTable'

const groups = [
  { name: '客户管理',
    items: [
    { name: '合作程度', type: 'erp_customer_cooperation', description: '客户档案的合作程度。' },
    { name: '客户类型', type: 'erp_customer_kind', description: '单体客户、连锁客户等类型。' },
    { name: '客商类型', type: 'erp_customer_merchant_type', description: '直营店、加盟店、KA 客户等。' },
    { name: '渠道', type: 'erp_customer_channel', description: '客户来源与开发渠道。' },
    { name: '公司性质', type: 'erp_company_nature', description: '企业、个体工商户等主体性质。' },
    { name: '等级', type: 'erp_customer_level', description: '客户等级。' },
    { name: '客户意向度', type: 'erp_customer_intention', description: '客户合作意向。' },
    { name: '业务状态', type: 'erp_customer_business_status', description: '客户业务状态选项；客户启停仍须走档案业务操作。' },
    { name: '配送方式', type: 'erp_delivery_method', description: '客户默认配送方式。' },
    { name: '结算方式', type: 'erp_settlement_method', description: '客户默认结算方式。' }
  ] },
  { name: 'CRM 拓客',
    items: [
    { name: '线索来源', type: 'erp_crm_lead_source', description: '线索的获取来源，可按实际获客渠道维护。' },
    { name: '线索等级', type: 'erp_crm_lead_level', description: '线索优先级与价值等级。' },
    { name: '线索阶段', type: 'erp_crm_lead_stage', description: '由销售手动选择；被业务引用后建议停用而非删除。' },
    { name: '跟进方式', type: 'erp_crm_follow_method', description: '电话、微信、上门等有效跟进方式。' },
    { name: '面谈类型', type: 'erp_crm_interview_type', description: '首次面谈、复访等面谈分类。' },
    { name: '入池原因', type: 'erp_crm_pool_reason', description: '客户或线索进入公海池的原因。' }
  ] },
  { name: '商品管理',
    items: [
    { name: '品牌', type: 'erp_product_brand', description: '商品品牌；商品档案的品牌字段及筛选使用。' },
    { name: '商品标签', type: 'erp_product_tag', description: '商品档案的商品标签；停用后新建商品不再可选，已保存的标签仍保留。' },
    { name: '计量单位', type: 'erp_product_unit', description: '商品基本单位与 MOQ 单位使用。' },
    { name: '温区', type: 'erp_product_temperature', description: '商品储运温区。' },
    { name: '包装方式', type: 'erp_product_package_type', description: 'SKU 包装方式。' }
  ] },
  { name: '库存管理',
    items: [
    { name: '其他入库原因', type: 'warehouse_other_in_reason', description: '其他入库单的业务原因；停用后新单不再可选，历史单据保留名称快照。' },
    { name: '其他出库原因', type: 'warehouse_other_out_reason', description: '其他出库单的业务原因；停用后新单不再可选，历史单据保留名称快照。' }
  ] },
  { name: '财务管理',
    items: [
    { name: '资金账户', type: 'finance_cash_account_master', custom: 'cashAccount', description: '收付款使用的正式资金账户档案。' },
    { name: '收款方式', type: 'finance_payment_method', description: '收款单资金记录使用的银行转账、现金等方式。' }
  ] }
]

export default {
  name: 'ErpBasicSettings',
  components: { BasicOptionTable, CashAccountTable },
  data () {
    return { groups, activeType: groups[0].items[0].type }
  },
  computed: {
    activeItem () {
      return this.groups.reduce((items, group) => items.concat(group.items), []).find(item => item.type === this.activeType)
    }
  },
  methods: {
    selectType ({ key }) {
      this.activeType = key
      this.$nextTick(() => {
        const el = this.$refs.settingsContent
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ block: 'nearest' })
        }
      })
    }
  }
}
</script>

<style scoped>
.settings-page {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 160px);
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 8px;
}
.page-intro { flex-shrink: 0; padding: 24px 28px 18px; border-bottom: 1px solid #edf0f4; }
.page-intro h2 { margin: 0 0 4px; font-size: 20px; font-weight: 600; color: #1f2937; }
.page-intro p { margin: 0; color: #687789; }
.settings-layout {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 204px minmax(0, 1fr);
  align-items: stretch;
}
.settings-navigation {
  position: sticky;
  top: 0;
  align-self: start;
  width: 100%;
  max-height: calc(100vh - 220px);
  padding: 16px 8px;
  border-right: 1px solid #edf0f4;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
.settings-navigation .ant-menu { border-right: 0; }
.settings-content { min-width: 0; padding: 24px 28px 32px; }
@media (max-width: 900px) {
  .settings-layout { grid-template-columns: 1fr; }
  .settings-navigation {
    position: static;
    max-height: 240px;
    padding: 8px;
    border-right: 0;
    border-bottom: 1px solid #edf0f4;
  }
  .settings-content { padding: 20px 16px; }
}
</style>
